import { ReactNode, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { parseQueryString } from '../utils';
import ListPagination from './CPagination';
import { IListColumn } from 'src/@types/search-params';

interface IGridView {
  columns: IListColumn[];
  title?: () => JSX.Element;
  totalRecord?: number;
  length?: number;
  children: ReactNode;
  noPagination?: boolean;
}
export default function CGridView({
  noPagination = false,
  children,
  title,
  totalRecord,
  length,
}: IGridView) {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  const handleChangePage = (page_number: number, page_size: number) => {
    setPageSize(page_size);
    setPageNumber(page_number);

    const params = parseQueryString(location.search);
    setSearchParams({
      ...searchParams,
      ...params,
      pageIndex: page_number.toString(),
      pageSize: page_size.toString(),
    });
  };
  // rest.onPageChange!(page_number, page_size);
  return (
    <>
      <div className='grid-view'>
        {title && title()}
        {children}
      </div>
      {!noPagination && (
        <div className='fixed left-0 bottom-0 bg-white w-full px-1'>
          <ListPagination
            pageNumber={pageNumber}
            total={totalRecord ?? 0}
            pageSize={pageSize}
            // onShowSizeChange={handleChangePage}
            handleChangePage={handleChangePage}
            length={length ?? 0}
            optionType={false}
          />
        </div>
      )}
    </>
  );
}
